import { FieldPath, FieldValues } from "react-hook-form";

import { notify } from "../../../../components/Notification";
import { ErrorResponse, getErrorMessages } from "../../../../services";
import { TradeWriteResult } from "../../../../services/holdings";
import {
  applyPanelError,
  MappedPanelError,
  PanelSubmitHelpers,
} from "../../panels";
import { notifyLedgerCashWarnings } from "../../utils";

export interface SubmitLedgerCommandArgs<Values extends FieldValues> {
  promise: Promise<TradeWriteResult>;
  successMessage: string;
  onRecorded: () => void;
  helpers: PanelSubmitHelpers<Values>;
  mapError: (messages: string[]) => MappedPanelError<FieldPath<Values>>;
  settlementAccountName: string | null;
}

/**
 * The tail every ledger write shares: report it, surface the D8 cash warning it
 * came back with, then hand a rejection to the panel that is still open.
 */
export const submitLedgerCommand = async <Values extends FieldValues>({
  promise,
  successMessage,
  onRecorded,
  helpers,
  mapError,
  settlementAccountName,
}: SubmitLedgerCommandArgs<Values>): Promise<void> => {
  try {
    const result = await promise;
    notify.success(successMessage);
    notifyLedgerCashWarnings(result, settlementAccountName);
    onRecorded();
  } catch (err: unknown) {
    applyPanelError(mapError(getErrorMessages(err as ErrorResponse)), helpers);
  }
};
